import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ChevronDown, ChevronRight } from "lucide-react";

const ACTION = { ekle: ["Ekleme", "bg-emerald-500/15 text-emerald-500"], guncelle: ["Güncelleme", "bg-blue-500/15 text-blue-500"], sil: ["Silme", "bg-red-500/15 text-red-500"],
  geri_al: ["Geri Alma", "bg-amber-500/15 text-amber-500"], kalici_sil: ["Kalıcı Silme", "bg-red-600/20 text-red-600"], yedekle: ["Yedekleme", "bg-primary/15 text-primary"],
  geri_yukle: ["Geri Yükleme", "bg-amber-500/15 text-amber-500"], disa_aktar: ["Dışa Aktarma", "bg-muted text-muted-foreground"], demo_temizle: ["Demo Temizliği", "bg-amber-500/15 text-amber-500"] };

const Diff = ({ before, after }) => {
  const keys = [...new Set([...Object.keys(before || {}), ...Object.keys(after || {})])].filter((k) => !["id", "created_at", "updated_at", "items"].includes(k) && JSON.stringify(before?.[k]) !== JSON.stringify(after?.[k]));
  if (!keys.length) return <div className="text-xs text-muted-foreground">Detay yok</div>;
  return (
    <table className="text-xs w-full"><tbody>
      {keys.map((k) => <tr key={k} className="border-t border-border/50"><td className="py-1 pr-3 font-semibold text-muted-foreground">{k}</td><td className="py-1 pr-3 text-red-400 line-through">{before?.[k] != null ? String(before[k]).slice(0, 60) : "-"}</td><td className="py-1 text-emerald-500">{after?.[k] != null ? String(after[k]).slice(0, 60) : "-"}</td></tr>)}
    </tbody></table>
  );
};

export const AuditLog = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [openId, setOpenId] = useState(null);
  useEffect(() => { const t = setTimeout(() => api.get("/audit-logs", { params: { q, limit: 300 } }).then((r) => setItems(r.data)).catch(() => {}), 250); return () => clearTimeout(t); }, [q]);

  return (
    <Card className="p-5" data-testid="audit-log">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div><h3 className="font-bold text-lg">İşlem Geçmişi</h3><p className="text-xs text-muted-foreground">Kim, ne zaman, hangi kaydı değiştirdi — önceki ve yeni değerlerle</p></div>
        <Input placeholder="Kullanıcı veya işlem ara..." value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs" data-testid="audit-search" />
      </div>
      <Table>
        <TableHeader><TableRow><TableHead className="w-8"></TableHead><TableHead>Tarih / Saat</TableHead><TableHead>Kullanıcı</TableHead><TableHead>İşlem</TableHead><TableHead>Açıklama</TableHead></TableRow></TableHeader>
        <TableBody>
          {items.map((a) => (
            <React.Fragment key={a.id}>
              <TableRow className="cursor-pointer" onClick={() => setOpenId(openId === a.id ? null : a.id)} data-testid={`audit-row-${a.id}`}>
                <TableCell>{openId === a.id ? <ChevronDown size={14} /> : <ChevronRight size={14} />}</TableCell>
                <TableCell className="num text-sm whitespace-nowrap">{fmtDateTime(a.at)}</TableCell>
                <TableCell className="font-semibold">{a.user_name}</TableCell>
                <TableCell><span className={`text-xs px-2 py-0.5 rounded ${(ACTION[a.action] || ["", "bg-muted"])[1]}`}>{(ACTION[a.action] || [a.action])[0]}</span></TableCell>
                <TableCell className="text-sm">{a.user_name} kullanıcısı {a.summary}.</TableCell>
              </TableRow>
              {openId === a.id && <TableRow><TableCell></TableCell><TableCell colSpan={4} className="bg-muted/30"><Diff before={a.before} after={a.after} /><div className="text-[10px] text-muted-foreground mt-1">Kayıt: {a.entity} · {a.entity_id}</div></TableCell></TableRow>}
            </React.Fragment>
          ))}
          {items.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-8 text-muted-foreground">Kayıt yok</TableCell></TableRow>}
        </TableBody>
      </Table>
    </Card>
  );
};
